module.exports = __webpack_public_path__ + "img/404.2291c6f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404.png
// module id = NeAH
// module chunks = 1